"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, /**
 * Primary UI component for user interaction
 */ "default", {
    enumerable: true,
    get: function() {
        return InputTextArea;
    }
});
var _jsxruntime = require("react/jsx-runtime");
var _react = /*#__PURE__*/ _interop_require_default(require("react"));
var _core = require("@mantine/core");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _object_destructuring_empty(o) {
    if (o === null || o === void 0) throw new TypeError("Cannot destructure " + o);
    return o;
}
function InputTextArea(_param) {
    var props = _extends({}, _object_destructuring_empty(_param));
    return /*#__PURE__*/ (0, _jsxruntime.jsx)(_jsxruntime.Fragment, {
        children: /*#__PURE__*/ (0, _jsxruntime.jsx)(_core.Textarea, _extends({}, props, {
            styles: {
                root: {
                    display: "flex",
                    flexDirection: "column"
                },
                description: {
                    order: 1,
                    marginBottom: "0"
                },
                label: {
                    order: -2,
                    color: "#000000"
                },
                input: {
                    order: -1
                },
                error: {
                    order: 2
                }
            }
        }))
    });
}
